export default __webpack_public_path__ + "static/media/app-x86_64-release.84dec060.apk";